import { UserContext } from 'libs/contexts';
import { formatPrice } from 'libs/utils';
import { useContext } from 'react';
import { useProductListNetPriceContext } from 'libs/contexts';
import { UserSource } from 'libs/enums';

export const H5ProductPrice = ({ data }) => {
  const netPriceListObj = useProductListNetPriceContext();
  const netPrice = netPriceListObj?.ProductListNetPrice?.find(
    (v) => v.skuSysNo === data.bestSkuSysNo,
  );
  const price = netPrice?.price || data?.lowestPrice;
  // 格式化价格
  const salePrice = !netPriceListObj?.loading ? formatPrice(price) : '';
  const userInfo = useContext(UserContext);
  const hidePrice = userInfo?.organizationSource === UserSource.outside && (!data.searchPriceFlag || !netPrice?.price);
  return (
    <div className="grid-item-price">
      <span className="currency">¥</span>
      {!userInfo?.name ? <span className="text">登录后可见</span> : hidePrice ? <span className="text">暂无报价</span> : (
        <>
          <span className="text">{salePrice}</span>
          <span className="separator">/</span>
          <span className="unit">{data?.unit}</span>
        </>
      )}
      {/* 移动端只展示选择区域的商品，所以不存在该区域不可售。只需要判断交易规则是否匹配 */}
      {/* {!data.hasTradeAgreementFlag && <span>(不可购买)</span>} */}
      {/* TODO 20231121 @李翔 */}
      {/* {!(data.hasTradeAgreementFlag && data.areaCanSale) && <span>(不可购买)</span>} */}
      <style jsx>{`
      .grid-item-price {
        color: #fa5400;
        margin-top: 10px;
        font-size: 12px;
        white-space: nowrap;
      }

      .grid-item-price .currency,
      .grid-item-price .separator,
      .grid-item-price .unit {
        font-size: 12px;
        margin-right: 2px;
      }

      .grid-item-price span {
        display: inline-block;
        vertical-align: middle;
      }

      .grid-item-price .hypen,
      .grid-item-price .text {
        font-size: 12px;
      }

      .grid-item-price .separator {
        margin-left: 2px;
      }
    `}</style>
    </div>
  );
};
